import { render, staticRenderFns } from "./sinterklaasshow.vue?vue&type=template&id=5b912950&"
import script from "./sinterklaasshow.vue?vue&type=script&lang=js&"
export * from "./sinterklaasshow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports